import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import Root from './Root';
import * as serviceWorker from './serviceWorker';
import { beforeSend, ignoreErrors } from './utils/error-reporting/sentry-util';
import {
  SENTRY_DSN,
  SENTRY_PROJECT_ID,
  CODE_VERSION,
  ENV,
  PROXIED_SENTRY,
} from './config/constants';

const releaseCfg = CODE_VERSION ? { release: CODE_VERSION } : {};

const SENTRY_PROXY_PATH = `/proxies/sentry/api/${SENTRY_PROJECT_ID}/envelope/`;

Sentry.init({
  dsn: SENTRY_DSN,
  ...(PROXIED_SENTRY && { tunnel: SENTRY_PROXY_PATH }),
  environment: ENV,
  ignoreErrors,
  beforeSend,
  ...releaseCfg,
});

ReactDOM.render(<Root />, document.getElementById('root'));

serviceWorker.unregister();
